import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { add } from "../../components/apipath";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function AddRequestForm() {

    const { token, mem_id, mem_status, authorized } = useAuth();
    const navigate = useNavigate();
    const QTY_IDS = [13, 14];
    const MEMO_IDS = [15, 20, 21];
    const ADDON_GROUPS = {
        CPA: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 19, 15, 20, 21, 17],
        CMA: [25, 26, 32],
        EA: [22, 23, 24],
        CIA: [27, 28, 29, 30],
        其他: [13, 14, 18],
    };
    const DOMESTIC_BOOK_IDS = [
        1,2,3,4,5,6,7,8,9,10,11,12,
        25,26,
        27,28,29,30
    ];
    
    const OVERSEAS_BOOK_IDS = [22, 23, 24];
    const BOOK_IDS = [...DOMESTIC_BOOK_IDS, ...OVERSEAS_BOOK_IDS];
    const BOOK_SUBJECT_MAP = {
    1: "FAR",
    2: "AUD",
    3: "REG",
    4: "BAR",
    5: "ISC",
    6: "TCP",
    7: "FAR",
    8: "AUD",
    9: "REG",
    10: "BAR",
    11: "ISC",
    12: "TCP",

    22: "EA Part 1",
    23: "EA Part 2",
    24: "EA Part 3",

    25: "CMA Part 1",
    26: "CMA Part 2",

    27: "CIA Part 1",
    28: "CIA Part 2",
    29: "CIA Part 3",
    30: "CIA Challenge Exam",
    };

    const getBookSubjectsFromAddons = (items = []) => {
    return [
        ...new Set(
        items
            .map(item => BOOK_SUBJECT_MAP[Number(item.id)])
            .filter(Boolean)
        )
    ];
    };


    const isBookAddon = (items = []) => {
    if (!Array.isArray(items)) return false;
    // 若是物件陣列
    if (items.length && typeof items[0] === 'object') {
        return items.some(i => BOOK_IDS.includes(Number(i.id)));
    }
    // 若是 id 陣列
    return items.some(i => BOOK_IDS.includes(Number(i)));
    };

    const getShippingInfo = (
        selectedItems,
        quantityMap = {},
        addressType = "domestic",
        deliver = "no"
    ) => {
        if (deliver !== "yes") {
            return {
                domesticCount: 0,
                overseasCount: 0,
                domesticBoxes: 0,
                overseasBoxes: 0,
                totalBoxes: 0,
                feePerBox: 0,
                shippingFee: 0,
            };
        }

        let domesticCount = 0;
        let overseasCount = 0;

        selectedItems.forEach((item) => {
            const id = Number(item.id);
            const qty = Number(quantityMap[id] || 1);

            if (DOMESTIC_BOOK_IDS.includes(id)) domesticCount += qty;
            if (OVERSEAS_BOOK_IDS.includes(id)) overseasCount += qty;
        });

        const domesticBoxes = Math.ceil(domesticCount / 2);
        const overseasBoxes = Math.ceil(overseasCount / 4);
        const totalBoxes = domesticBoxes + overseasBoxes;
        const feePerBox = addressType === "foreign" ? 1200 : 100;
        const shippingFee = totalBoxes * feePerBox;

        return {
            domesticCount,
            overseasCount,
            domesticBoxes,
            overseasBoxes,
            totalBoxes,
            feePerBox,
            shippingFee,
        };
    };

    useEffect(() => {
        if (!authorized || String(mem_status) !== "1") {
            Swal.fire({
                icon: 'warning',
                title: '學員專屬功能',
                text: '此頁面僅限學員使用，請先完成購買並登入',
                confirmButtonText: '了解',
                confirmButtonColor: '#224040',
            }).then(() => {
                navigate('/member/memberlogin');
            });
        }
    }, []);
    
    const [formData, setFormData] = useState({
        mem_id: mem_id,
        deliver: "no",
        address: "",
        address_type: "domestic",
        overseas_phone: "",
        invoice: "personal",
        company_name: "",
        company_tax: "",
        remit_time: "",
        remit_name: "",
        status: "審核中",
        total_amount: 0,
        add_on_items: [],
        quantityMap: {},
        memoMap: {},
        book_requested_date: "",
        book_memo: "",
    });
    
    const selectedBookSubjects =
        getBookSubjectsFromAddons(formData.add_on_items);

    const showBookRequestFields =
        isBookAddon(formData.add_on_items);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [agreementChecked, setAgreementChecked] = useState({
        reviewedTerms: false,
        understandPolicy: false,
        acceptTerms: false,
    });

    const isAgreementValid = () => {
        return agreementChecked.reviewedTerms && agreementChecked.understandPolicy && agreementChecked.acceptTerms;
    };
    
    const handleAgreementChange = (e) => {
        const { name, value } = e.target;
        setAgreementChecked(prev => ({
            ...prev,
            [name]: value === "yes",
        }));
    };

    const [addOnOptions, setAddOnOptions] = useState([]);
    
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const authData = JSON.parse(localStorage.getItem("auth"));
                if (authData && authData.chinese_name) {
                    setFormData((prevData) => ({
                        ...prevData,
                        studentName: authData.chinese_name,
                        account: authData.account,
                    }));
                }
            } catch (error) {
                console.error("無法解析 auth 資料", error);
            }
    
            try {
                const response = await axios.get(`${add}addon_items`);
                setAddOnOptions(response.data);
            } catch (err) {
                console.error("載入加購項目錯誤", err);
            }
        };
    
        fetchInitialData();
    }, []);

    // 計算總金額
    const calculateTotal = (
        selectedItems,
        quantityMapArg = formData.quantityMap,
        addressTypeArg = formData.address_type,
        deliverArg = formData.deliver
    ) => {
        const itemTotal = selectedItems.reduce((sum, item) => {
            const qty = Number(quantityMapArg[item.id] || 1);
            return sum + Number(item.price) * qty;
        }, 0);

        const shippingInfo = getShippingInfo(
            selectedItems,
            quantityMapArg,
            addressTypeArg,
            deliverArg
        );

        setFormData(prev => ({
            ...prev,
            total_amount: itemTotal + shippingInfo.shippingFee,
        }));
    };

    const shippingInfo = getShippingInfo(
        formData.add_on_items,
        formData.quantityMap,
        formData.address_type,
        formData.deliver
    );

    // 更新表單欄位
    const handleChange = (e) => {
        const { name, value } = e.target;

        const newFormData = {
            ...formData,
            [name]: value
        };

        setFormData(newFormData);

        if (["deliver", "address_type"].includes(name)) {
            calculateTotal(
                newFormData.add_on_items,
                newFormData.quantityMap,
                newFormData.address_type,
                newFormData.deliver
            );
        }
    };

    // 處理加購項目變更
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        const selectedId = parseInt(value, 10);

        const item = addOnOptions.find(i => Number(i.id) === selectedId);
        if (!item) return;

        setFormData(prev => {
            let updatedItems = [...prev.add_on_items];
            let newQuantityMap = { ...prev.quantityMap };
            let newMemoMap = { ...prev.memoMap };

            if (checked) {
                if (!updatedItems.some(i => Number(i.id) === selectedId)) {
                    updatedItems.push(item);
                }

                if (QTY_IDS.includes(selectedId) && !newQuantityMap[selectedId]) {
                    newQuantityMap[selectedId] = 1;
                }

                if (MEMO_IDS.includes(selectedId) && newMemoMap[selectedId] === undefined) {
                    newMemoMap[selectedId] = "";
                }
            } else {
                updatedItems = updatedItems.filter(i => Number(i.id) !== selectedId);
                delete newQuantityMap[selectedId];
                delete newMemoMap[selectedId];
            }

            const itemTotal = updatedItems.reduce((sum, item) => {
                const qty = Number(newQuantityMap[item.id] || 1);
                return sum + Number(item.price) * qty;
            }, 0);

            const shippingInfo = getShippingInfo(
                updatedItems,
                newQuantityMap,
                prev.address_type,
                prev.deliver
            );

            return {
                ...prev,
                add_on_items: updatedItems,
                quantityMap: newQuantityMap,
                memoMap: newMemoMap,
                total_amount: itemTotal + shippingInfo.shippingFee,
            };
        });
    };
    
    const handleSubmit = async (e) => {
    e.preventDefault();
    
    const missingMemo = formData.add_on_items
    .map(i => Number(i.id))
    .filter(id => MEMO_IDS.includes(id))
    .some(id => !(formData.memoMap[id] || "").trim());

    if (missingMemo) {
    Swal.fire({
        icon: "warning",
        title: "請填寫備註",
        text: "您勾選了需要備註的加購項目，請先填寫備註再送出。",
        confirmButtonText: "確認",
    });

    setIsSubmitting(false);
    return;
    }
    // 如果沒有勾選所有同意選項，則顯示錯誤
    if (!isAgreementValid()) {
        Swal.fire({
            icon: "warning",
            title: "請確認所有條款",
            text: "請確保您已勾選所有「同意與閱讀」選項後再提交。",
            confirmButtonText: "確認",
        });
        return;
    }

    if (
        formData.address_type === "foreign" &&
        !formData.overseas_phone.trim()
    ) {
        Swal.fire({
            icon: "warning",
            title: "請填寫海外手機號碼",
        });
        return;
    }

    setIsSubmitting(true);

    try {
        const dataToSend = {
        ...formData,
        add_on_items: formData.add_on_items.map(item => item.id).join(","),
        memo: formData.add_on_items
            .map(item => {
            const id = Number(item.id);
            const qty = formData.quantityMap[id] || 1;
            const note = (formData.memoMap[id] || "").trim();

            if (QTY_IDS.includes(id)) return `${item.name} x${qty}`;
            if (MEMO_IDS.includes(id)) return note;
            return item.name;
            })
            .filter(Boolean)
            .join(" | "),

        book_request: showBookRequestFields
            ? {
                enabled: true,
                core_subject: selectedBookSubjects.join(","),
                delivery_method:
                    formData.deliver === "yes"
                    ? "post"
                    : "pickup",
                requested_date:
                    formData.book_requested_date || null,
                address: formData.address || "",
                overseas_phone:
                    formData.address_type === "foreign"
                    ? formData.overseas_phone
                    : "",
                memo: formData.book_memo || "",
                }
            : {
                enabled: false,
                },
        };

        const response = await axios.post(`${add}`, dataToSend, { headers: { token } });

        if (response.status === 200) {
            Swal.fire({
                icon: "success",
                title: "加購申請成功",
                text: "請等待審核！",
                confirmButtonText: "確認",
            });
            // if (isBookAddon(formData.add_on_items)) {
            
            //     const result = await Swal.fire({
            //     icon: "question",
            //     title: "需要現在申請領書時間嗎？",
            //     text: "您已加購書本，可立即前往選擇領書時間與方式。",
            //     showCancelButton: true,
            //     confirmButtonText: "前往領書申請",
            //     cancelButtonText: "稍後再說",
            //     confirmButtonColor: "#224040",
            // });
            // if (result.isConfirmed) {
            //     navigate("/member/book");
            //     return;
            // }
            // }
            navigate("/member");
            }
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "提交失敗",
                    text: error.response?.data?.message || "請稍後再試",
                    confirmButtonText: "確認",
                });
            }

            setIsSubmitting(false);
        };
        const groupedAddOnOptions = Object.entries(ADDON_GROUPS).map(([groupName, ids]) => ({
            groupName,
            items: ids
                .map(id => addOnOptions.find(item => Number(item.id) === id))
                .filter(Boolean)
        }));
    return (
        <div className="container mb100 mt100">
            <h2 className="font-weight-bold pb-5 text-center">Becker CPA/CMA/EA (美國註冊會計師) 學員加購_線上報名表</h2>
            <div className="card w-75 p-5 m-auto">
                <div className="card-body">
                        <div className="mt-5 contract-terms">
                            <h4 className="font-weight-bold mb-4">
                                Becker 系列產品購買須知與服務規定
                            </h4>

                            <p>
                                敬請於購買前完整閱讀本購買須知與相關規定，確認了解所購方案內容、費用、退費規定、軟體及課程使用效期、線上課程使用方式及相關權益後，再完成訂購及付款。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                1. 訂購、付款及退費規定
                            </h5>

                            <p>
                                購買 Becker Taiwan（捷進顧問有限公司，以下簡稱「捷進」）各項產品或方案者，須填妥訂購資料、完整審閱並同意本購買須知後完成付款，始完成訂購程序。
                            </p>

                            <p>
                                購買前請確認所購買之產品、方案內容及費用，並確認已完成至少五日之契約審閱期間。
                            </p>

                            <p>
                                本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條得排除消費者保護法第 19 條七日解除權之合理例外情事。惟於下列條件均符合時，購買後七日內得提出退費申請：
                            </p>

                            <ul>
                                <li>尚未領取實體教材或其他實體商品。</li>
                                <li>尚未登入或啟用任何 Becker 原廠學習帳號。</li>
                                <li>尚未登入或使用「捷進中文雲端教室」之任何線上課程。</li>
                                <li>尚未開始使用方案所包含之其他數位內容或服務。</li>
                            </ul>

                            <p>
                                若已使用顧問諮詢服務，退費時每一已使用之諮詢階段將扣除 NT$1,000 諮詢服務費。
                            </p>

                            <p>
                                教材一經領取，或任一學習帳號、線上課程或數位服務經登入、啟用或使用後，除依法令另有規定外，不得要求退費或暫停使用效期。
                            </p>

                            <p>
                                購買者應為完全行為能力人；限制行為能力人購買時，應已取得法定代理人同意。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                2. 帳號、聯絡方式及使用責任
                            </h5>

                            <p>
                                購買者應提供可於產品使用期間正常收件之有效 E-mail 信箱，並自行定期查收信件。
                            </p>

                            <p>
                                Becker 原廠軟體、捷進中文雲端教室、課程、服務通知及其他與購買方案相關之重要資訊，原則上均透過購買者所留存之 E-mail 或其他線上聯絡方式提供。
                            </p>

                            <p>
                                若因購買者未定期查收信件、未更新聯絡資訊或其他可歸責於購買者之原因而影響相關權益，由購買者自行負責。
                            </p>

                            <p>
                                購買者取得學習帳號後，應妥善保管帳號及密碼，不得提供他人使用。以購買者帳號及密碼登入系統之行為，原則上推定為購買者本人之操作。
                            </p>

                            <p>
                                若因非可歸責於 Becker Taiwan（捷進）之原因造成帳號、密碼或個人資料外洩，購買者應立即通知 Becker Taiwan；捷進將提供必要協助，但對因此產生之損害不負法律責任。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                3. Becker 原廠教材及軟體使用規定
                            </h5>

                            <p>
                                Becker CPA、CMA、EA Exam Review 系列為 Becker Professional Education 提供之原版教材及學習軟體。
                            </p>

                            <p>方案內所包含之：</p>

                            <ul>
                                <li>Becker 原廠軟體</li>
                                <li>電子或實體教材</li>
                                <li>捷進中文線上課程</li>
                                <li>顧問諮詢服務</li>
                                <li>線上發問或其他加值服務</li>
                            </ul>

                            <p>
                                均限原購買者本人使用。
                            </p>

                            <p>
                                不得以任何方式進行轉售、轉贈、轉讓、共用帳號或提供第三人使用。若經查證有違反情形，Becker Taiwan（捷進）得停止相關帳號及服務使用權限，並依契約及相關法律規定處理。
                            </p>

                            <p>
                                為維護服務品質及確認帳號正確使用，Becker Professional Education 及 Becker Taiwan（捷進）得於法令允許範圍內蒐集及分析帳號登入時間、IP Address 及其他與服務使用相關之必要資訊。
                            </p>

                            <p>
                                如系統發現多人使用同一帳號或其他異常使用情形，Becker Taiwan（捷進）得暫停或終止該帳號之使用權限。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                4. Becker 原廠軟體使用效期
                            </h5>

                            <h6 className="font-weight-bold mt-3">CPA</h6>

                            <p>
                                Becker CPA Exam Review 及 Becker CPA Exam Final Review 使用權限，自產品註冊日起算 24 個月。
                            </p>

                            <h6 className="font-weight-bold mt-3">CMA</h6>

                            <p>
                                Becker CMA Exam Review 使用權限，自產品註冊日起算 24 個月。
                            </p>

                            <h6 className="font-weight-bold mt-3">EA</h6>

                            <p>
                                Becker EA Exam Review 使用權限，自產品註冊日起算 12 個月。
                            </p>

                            <p>
                                所有方案內包含之課程、教材及相關加值服務，均應於各自規定之有效期間內領取及使用。
                            </p>

                            <p>
                                CPA、CMA 方案原則上提供電子教科書，不包含紙本教科書。若因個人需求加購紙本教科書，加購價格依 Becker 當時規定之售價及相關國際運費計算。
                            </p>

                            <p>
                                如遇 Becker 原廠更新教材版本，符合新版紙本教材加購資格者，應依 Becker Taiwan 當時公告之資格、證明文件及價格辦理。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                5. Unlimited Access 持續展延規定
                            </h5>

                            <p>
                                購買明確包含 Unlimited Access 持續展延資格之 CPA 或 EA 方案者，得依下列規定申請展延。
                            </p>

                            <p>
                                未包含 Unlimited Access 資格之產品，如 Becker Taiwan 當時仍提供相關升級方案，購買者得依公告之價差及規定申請升級。
                            </p>

                            <h6 className="font-weight-bold mt-3">CPA</h6>

                            <p>
                                持有 Unlimited Access 資格之 CPA 學員，應於每次軟體效期到期日前 30 日內，提供本人即將參加該科考試之有效考場預約證明（Prometric Appointment Confirmation）。
                            </p>

                            <p>
                                經審核符合資格後，得免費展延該科 Becker 軟體使用效期 6 個月。
                            </p>

                            <p>
                                若未於原使用效期屆滿前提出申請並完成審核，原使用效期及持續展延資格可能失效。
                            </p>

                            <p>
                                展延效期自原到期日翌日起算，不得自行要求提前或延後起算。
                            </p>

                            <h6 className="font-weight-bold mt-3">EA</h6>

                            <p>
                                持有 Unlimited Access 資格之 EA 學員，得於原使用效期內提供符合規定之考試預約證明，申請單科延長使用效期 4 個月。
                            </p>

                            <p>
                                展延效期自原到期日翌日起算，並應於規定期限內提出申請。
                            </p>

                            <p>
                                Unlimited Access 之實際資格條件、證明文件及展延規則，如 Becker 原廠日後調整，以 Becker Taiwan 最新公告為準。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                6. Becker Taiwan 中文線上課程使用規定
                            </h5>

                            <p>
                                Becker Taiwan（捷進）提供之中文課程全面採線上形式提供，不提供實體面授課程。
                            </p>

                            <p>
                                中文課程影片統一透過「捷進中文雲端教室」提供予符合資格之購買者觀看。
                            </p>

                            <h6 className="font-weight-bold mt-3">一般使用原則</h6>

                            <ul>
                                <li>中文課程僅限購買者本人使用。</li>
                                <li>課程使用資格及使用期限依各方案所載規定辦理。</li>
                                <li>原則上應於 Becker 軟體或相關方案之有效期限內完成使用。</li>
                                <li>中文課程主要目的為協助考生準備相關專業考試，因此應於通過相關考試前使用。</li>
                                <li>課程影片之上架時間、開放期間、課程內容及實際提供範圍，以 Becker Taiwan 或「捷進中文雲端教室」當期公告為準。</li>
                                <li>已使用之課程時數、觀看點數或其他課程權益，不得要求轉讓、交換或重複使用。</li>
                            </ul>

                            <h6 className="font-weight-bold mt-3">CPA 中文課程</h6>

                            <p>
                                購買包含中文課程或相關中文加值服務之 CPA 方案者，其可使用之中文課程時數依購買方案所載之線上中文課程時數及額外贈送時數計算。
                            </p>

                            <p>
                                全科方案及非全科方案之實際課程時數額度，以購買當時之方案內容為準。
                            </p>

                            <p>
                                如方案採觀看點數方式計算，每一點數原則上代表 3 小時課程使用額度。
                            </p>

                            <p>
                                學員於使用點數開啟課程後，即視為已使用該次課程額度，不得要求恢復、轉讓或更換。
                            </p>

                            <h6 className="font-weight-bold mt-3">EA 中文課程</h6>

                            <p>
                                購買包含 EA 中文課程之方案者，得於方案有效期間內使用「捷進中文雲端教室」所提供之相關課程。
                            </p>

                            <p>
                                實際課程內容、總時數及上架進度，以 Becker Taiwan 當期課程公告為準。
                            </p>

                            <p>
                                若學員已使用該科中文課程但應試未通過，得依 Becker Taiwan 當期所公告之資格及規定，檢附未通過之成績證明申請該科中文課程再次使用一次。
                            </p>

                            <h6 className="font-weight-bold mt-3">中文課程加購</h6>

                            <p>
                                未包含中文課程之方案，如 Becker Taiwan 當時開放中文課程加購，可依公告價格及課程上架規劃辦理。
                            </p>

                            <p>
                                單堂中文課程原則上以 3 小時為一單位；實際價格及計價方式依購買當時公告為準。
                            </p>

                            <p>
                                除方案另有明確約定外，單獨加購中文課程者不包含中文講師線上解題服務。
                            </p>

                            <h6 className="font-weight-bold mt-3">
                                線上課程智慧財產權
                            </h6>

                            <p>
                                「捷進中文雲端教室」內所有課程影片、講義及相關教材，均受著作權及相關智慧財產權保護。
                            </p>

                            <p>未經授權不得：</p>

                            <ul>
                                <li>錄音或錄影</li>
                                <li>翻拍或截錄</li>
                                <li>下載或重製</li>
                                <li>公開播放</li>
                                <li>上傳至其他網站或平台</li>
                                <li>分享帳號予第三人</li>
                                <li>以其他方式複製、散布或提供第三人使用</li>
                            </ul>

                            <p>
                                違反者，Becker Taiwan（捷進）得立即停止相關課程及帳號使用權限，並依法追究責任。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                7. 顧問諮詢服務
                            </h5>

                            <p>
                                Becker Taiwan（捷進）所提供之考程顧問諮詢服務，係針對購買方案所載範圍，提供考試準備、報考流程說明及相關文件總檢等服務。
                            </p>

                            <p>
                                所有顧問諮詢服務均採線上或電話方式提供。
                            </p>

                            <p>
                                實際使用方式、預約方式、服務次數及單次諮詢時間，以各方案購買當時之內容及 Becker Taiwan 公告為準。
                            </p>

                            <h6 className="font-weight-bold mt-3">CPA</h6>

                            <p>
                                購買 CPA 專業方案或全修方案者，依方案內容享有線上或電話顧問諮詢服務。
                            </p>

                            <p>
                                購買選修方案者，如方案內容包含三次顧問諮詢，服務範圍原則如下：
                            </p>

                            <ol>
                                <li>選州及報考資格流程說明</li>
                                <li>學歷認證流程說明</li>
                                <li>考試報名及考場預約流程說明</li>
                            </ol>

                            <p>
                                實際服務內容及時間以購買方案所載規定為準。
                            </p>

                            <h6 className="font-weight-bold mt-3">EA</h6>

                            <p>
                                EA 顧問諮詢服務以線上方式提供，包括線上文字說明、視訊、影片講解或其他 Becker Taiwan 公告之線上服務形式。
                            </p>

                            <p>
                                所有報考流程顧問諮詢及文件總檢服務均為購買者本人之權益。
                            </p>

                            <p>
                                為避免溝通錯誤或資訊遺漏，相關說明及服務原則上僅提供予購買者本人。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                8. 報考資格及學分評估聲明
                            </h5>

                            <p>
                                捷進顧問有限公司（Becker Taiwan）提供之學分評估、報考資格說明及顧問建議均屬參考資訊，不構成任何報考資格核准或保證。
                            </p>

                            <p>
                                實際報考資格應以各考試主辦機構、學歷認證機構、州政府機關、專業協會或其他具正式審查權限之官方單位最終審查結果為準。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                9. 原廠產品及服務變更
                            </h5>

                            <p>
                                如因 Becker Professional Education 或其他原廠供應商：
                            </p>

                            <ul>
                                <li>停止提供某項產品或服務</li>
                                <li>修改產品內容</li>
                                <li>更新產品版本</li>
                                <li>調整軟體規格</li>
                                <li>修改使用期限或相關政策</li>
                            </ul>

                            <p>
                                Becker Taiwan（捷進）得依原廠政策進行必要調整。
                            </p>

                            <p>
                                如涉及購買者既有權益，將依適用法令、原廠政策及購買當時之契約內容辦理。
                            </p>

                            <p>
                                Becker Taiwan（捷進）亦保留依產品更新、考試制度變更、平台營運需求等因素，調整中文線上課程之內容、上架時程及服務方式之權利。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                10. 個人資料及隱私權聲明
                            </h5>

                            <p>
                                捷進顧問有限公司將依個人資料保護法相關規定蒐集、處理及利用購買者之個人資料。
                            </p>

                            <h6 className="font-weight-bold mt-3">蒐集目的</h6>

                            <p>包括但不限於：</p>

                            <ul>
                                <li>040 行銷</li>
                                <li>069 契約、類似契約或其他法律關係事務</li>
                                <li>090 消費者、客戶管理與服務</li>
                                <li>157 調查、統計與研究分析</li>
                                <li>181 其他經營合於營業登記項目或組織章程所定之業務</li>
                                <li>182 其他諮詢與顧問服務</li>
                            </ul>

                            <h6 className="font-weight-bold mt-3">
                                蒐集之個人資料
                            </h6>

                            <p>依實際服務需要，可能包含：</p>

                            <ul>
                                <li>姓名</li>
                                <li>英文姓名</li>
                                <li>E-mail</li>
                                <li>電話</li>
                                <li>身分證明資料</li>
                                <li>匯款或金融帳戶資訊</li>
                                <li>購買紀錄</li>
                                <li>得知 Becker Taiwan 之管道</li>
                                <li>在職狀況</li>
                                <li>就讀或畢業學校及科系</li>
                                <li>其他完成訂購及提供服務所必要之資料</li>
                            </ul>

                            <h6 className="font-weight-bold mt-3">
                                個人資料使用
                            </h6>

                            <p>
                                捷進顧問有限公司將於提供產品及服務所必要之期間及範圍內使用上述資料，包括：
                            </p>

                            <ul>
                                <li>確認訂購及付款</li>
                                <li>註冊學習帳號</li>
                                <li>提供教材或商品</li>
                                <li>開通「捷進中文雲端教室」</li>
                                <li>提供學員服務及顧問諮詢</li>
                                <li>傳送產品或服務通知</li>
                                <li>客戶管理</li>
                                <li>行銷及服務分析</li>
                            </ul>

                            <p>
                                除法令另有規定或經本人同意外，不會將個人資料提供予無關之第三人或作不當利用。
                            </p>

                            <p>
                                如購買者所提供之資料不完整或不正確，可能影響產品開通、服務提供或契約履行。
                            </p>

                            <p>
                                如欲依個人資料保護法行使相關權利，可聯繫：
                                <br />
                                <a href="mailto:service@beckertw.com">
                                    service@beckertw.com
                                </a>
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                11. Becker Taiwan 聯絡方式
                            </h5>

                            <p>
                                捷進顧問有限公司
                                <br />
                                Becker Taiwan
                                <br />
                                電話：02-2700-0053
                                <br />
                                E-mail：
                                <a href="mailto:service@beckertw.com">
                                    service@beckertw.com
                                </a>
                                <br />
                                官方網站：
                                <a
                                    href="https://www.beckertw.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.beckertw.com
                                </a>
                                <br />
                                官方客服 LINE：
                                <a
                                    href="https://page.line.me/vtz1908l?openQrModal=true"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://page.line.me/vtz1908l?openQrModal=true
                                </a>
                            </p>

                            <p>
                                Becker Taiwan 所提供之課程與顧問服務均採線上方式提供；中文課程透過「捷進中文雲端教室」提供。
                            </p>

                            <hr />

                            <h5 className="font-weight-bold mt-4">
                                12. 付款資訊
                            </h5>

                            <h6 className="font-weight-bold mt-3">台灣付款</h6>

                            <p>
                                收款人戶名：捷進顧問有限公司
                                <br />
                                受款銀行：華南商業銀行信維分行
                                <br />
                                銀行代碼：008
                                <br />
                                收款人帳號：149-10-010062-0
                            </p>

                            <p>
                                付款金額依實際購買方案價格為準。
                            </p>

                            <p>
                                如另購買需寄送之實體書籍或商品，相關運費依購買時公告之費用另計。
                            </p>

                            <h6 className="font-weight-bold mt-3">海外付款</h6>

                            <p>
                                Recipient Name: Direct Line Consulting Co.
                                <br />
                                Account Number: 149-10-010062-0
                                <br />
                                Bank: Hua Nan Commercial Bank Ltd.
                                <br />
                                Branch: Hsin-Wei Branch
                                <br />
                                SWIFT Code: HNBKTWTP149
                                <br />
                                Bank Address: 2F, No. 6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan
                            </p>

                            <p>
                                海外匯款應以新台幣全額到匯。國際匯款、中轉銀行或其他金融機構收取之手續費，由付款人自行負擔。
                            </p>

                            <p>
                                如另購買需由 Becker 原廠寄送之實體教材，國際運費依購買時實際公告為準。
                            </p>
                        </div>

                    <div className="container mb100 mt100">
                        <h2 className="font-weight-bold pb-5 text-center">Becker CPA (美國註冊會計師) 學員加購_線上報名表</h2>
                        <div className="card w-100 p-5 m-auto">
                            <div className="card-body">
                                <p>請完整閱讀此表單，確認內容後填寫並完成繳費。</p>
                                {/* 學員姓名 */}
                                <div className="form-group mb-4">
                                    <label>學員姓名</label>
                                    <input type="text" className="form-control" name="studentName" value={formData.studentName} readOnly />
                                </div>

                                {/* 備註 */}
                                <div className="form-group mb-4">
                                    <label>您的 Becker 軟體帳號（email 全址）*</label>
                                    <input className="form-control" name="account" value={formData.account} onChange={handleChange} />
                                </div>
                                <form onSubmit={handleSubmit}>
                                    {/* 加購項目 */}
                                    <label>選擇加購項目</label>
                                    <div className="checkbox-group mb-5 mt-3">
                                        {groupedAddOnOptions.map(({ groupName, items }) => (
                                            <div key={groupName} className="mb-4">
                                                <h5 className="fw-bold mb-3">{groupName}</h5>

                                                {items.map((item) => (
                                                    <div key={item.id} className="form-check mb-3">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            value={item.id}
                                                            onChange={handleCheckboxChange}
                                                            checked={formData.add_on_items.some(i => Number(i.id) === Number(item.id))}
                                                        />
                                                        <label className="form-check-label mt-2">
                                                            {item.name} - NT${item.price}
                                                        </label>

                                                        {(() => {
                                                            const iid = Number(item.id);
                                                            const selected = formData.add_on_items.some(i => Number(i.id) === iid);
                                                            if (!QTY_IDS.includes(iid) || !selected) return null;

                                                            return (
                                                                <input
                                                                    type="number"
                                                                    className="form-control mt-2"
                                                                    placeholder="請輸入數量"
                                                                    min={1}
                                                                    value={formData.quantityMap[iid] || 1}
                                                                    onChange={(e) => {
                                                                        const value = parseInt(e.target.value, 10) || 1;
                                                                        const newQuantityMap = {
                                                                            ...formData.quantityMap,
                                                                            [iid]: value
                                                                        };

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            quantityMap: newQuantityMap
                                                                        }));

                                                                        calculateTotal(
                                                                            formData.add_on_items,
                                                                            newQuantityMap,
                                                                            formData.address_type,
                                                                            formData.deliver
                                                                        );
                                                                    }}
                                                                />
                                                            );
                                                        })()}

                                                        {(() => {
                                                            const iid = Number(item.id);
                                                            const selected = formData.add_on_items.some(i => Number(i.id) === iid);
                                                            if (!MEMO_IDS.includes(iid) || !selected) return null;

                                                            return (
                                                                <input
                                                                    type="text"
                                                                    className="form-control mt-2"
                                                                    placeholder="請輸入備註"
                                                                    value={formData.memoMap[iid] || ""}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            memoMap: { ...prev.memoMap, [iid]: value }
                                                                        }));
                                                                    }}
                                                                />
                                                            );
                                                        })()}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    {/* 是否郵寄 */}
                                    <div className="form-group mb-4">
                                        <label>是否需要郵寄？</label>
                                        <select name="deliver" className="form-control" value={formData.deliver} onChange={handleChange}>
                                            <option value="no">否</option>
                                            <option value="yes">是</option>
                                        </select>
                                    </div>
                                    {showBookRequestFields && (
                                        <div className="card p-4 mb-4 border">
                                            <h4 className="fw-bold mb-3">領書申請資料</h4>

                                            <div className="form-group mb-4">
                                            <label className="mb-2">本次加購書本科目</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={selectedBookSubjects.join(", ")}
                                                readOnly
                                            />
                                            </div>

                                            {formData.deliver === "no" && (
                                                <div className="form-group mb-4">
                                                    <label>欲領取日期（請選擇三日後）</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="book_requested_date"
                                                        value={formData.book_requested_date}
                                                        onChange={handleChange}
                                                        min={
                                                            new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)
                                                                .toISOString()
                                                                .split("T")[0]
                                                        }
                                                        required
                                                    />
                                                </div>
                                            )}

                                            <div className="form-group mb-4">
                                            <label>備註</label>
                                            <textarea
                                                className="form-control"
                                                name="book_memo"
                                                rows="3"
                                                value={formData.book_memo}
                                                onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        )}
                                    {formData.deliver === "yes" && (
                                        <>
                                            <div className="form-group mb-4">
                                                <label>寄送地區</label>
                                                <select
                                                    name="address_type"
                                                    className="form-control"
                                                    value={formData.address_type}
                                                    onChange={handleChange}
                                                >
                                                    <option value="domestic">台灣國內</option>
                                                    <option value="foreign">海外</option>
                                                </select>
                                            </div>

                                            <div className="form-group mb-4">
                                                <label>郵寄地址</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="address"
                                                    value={formData.address}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            {formData.address_type === "foreign" && (
                                                <div className="form-group mb-4">
                                                    <label>
                                                        海外手機號碼 <span className="text-danger">*</span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="overseas_phone"
                                                        value={formData.overseas_phone}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}
                                    

                                    {/* 發票類型 */}
                                    <div className="form-group mb-4">
                                        <label>發票類型</label>
                                        <select name="invoice" className="form-control" value={formData.invoice} onChange={handleChange}>
                                            <option value="personal">個人發票</option>
                                            <option value="company">公司發票</option>
                                        </select>
                                    </div>

                                    {/* 公司資訊（僅當選擇公司發票時顯示） */}
                                    {formData.invoice === "company" && (
                                        <>
                                            <div className="form-group mb-4">
                                                <label>公司名稱</label>
                                                <input type="text" className="form-control" name="company_name" value={formData.company_name} onChange={handleChange} />
                                            </div>
                                            <div className="form-group mb-4">
                                                <label>公司統編</label>
                                                <input type="text" className="form-control" name="company_tax" value={formData.company_tax} onChange={handleChange} />
                                            </div>
                                        </>
                                    )}

                                    {/* 匯款資訊 */}
                                    <div className="form-group mb-4">
                                        <label>匯款時間</label>
                                        <input type="datetime-local" className="form-control" name="remit_time" value={formData.remit_time} onChange={handleChange} required />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label>匯款人姓名 / 轉帳帳號</label>
                                        <input type="text" className="form-control" name="remit_name" value={formData.remit_name} onChange={handleChange} required />
                                    </div>
                                    
                                    {formData.deliver === "yes" && shippingInfo.totalBoxes > 0 && (
                                        <div className="alert alert-secondary mb-4">
                                            <div>國內書本數：{shippingInfo.domesticCount} 本（每 2 本 1 箱）</div>
                                            <div>EA 書本數：{shippingInfo.overseasCount} 本（每 3 本 1 箱）</div>
                                            <div>總箱數：{shippingInfo.totalBoxes} 箱</div>
                                            <div>每箱運費：NT${shippingInfo.feePerBox}</div>
                                            <div><strong>書籍運費：NT${shippingInfo.shippingFee}</strong></div>
                                        </div>
                                    )}
                                    {/* 顯示總金額 */}
                                    <div className="form-group mb-4">
                                        <label>總金額 (新台幣)</label>
                                        <input type="text" className="form-control" name="total_amount" value={formData.total_amount} readOnly />
                                    </div>
                                    {/* 確認閱讀條款 */}
                                    <div className="form-group mb-4">
                                        <label>報名與購買前，是否已完整審閱上述購買須知與相關規定？</label>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="reviewedTerms" value="yes" onChange={handleAgreementChange} />
                                            <label className="form-check-label">是，我已閱讀並同意</label>
                                        </div>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="reviewedTerms" value="no" onChange={handleAgreementChange} />
                                            <label className="form-check-label">否，我尚未理解</label>
                                        </div>
                                    </div>

                                    {/* 確認理解購買須知 */}
                                    <div className="form-group mb-4">
                                        <label>是否瞭解及接受 Becker 方案購買須知與相關規定？</label>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="understandPolicy" value="yes" onChange={handleAgreementChange} />
                                            <label className="form-check-label">是，我已詳閱並理解</label>
                                        </div>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="understandPolicy" value="no" onChange={handleAgreementChange} />
                                            <label className="form-check-label">否，我尚未理解</label>
                                        </div>
                                    </div>
                                   {/* 確認接受條款 */}
                                    <div className="form-group mb-4">
                                        <label>是否接受所有購買與退費相關條款？</label>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="acceptTerms" value="yes" onChange={handleAgreementChange} />
                                            <label className="form-check-label">是，我接受所有條款</label>
                                        </div>
                                        <div className="form-check">
                                            <input type="radio" className="form-check-input" name="acceptTerms" value="no" onChange={handleAgreementChange} />
                                            <label className="form-check-label">否，我尚未接受</label>
                                        </div>
                                    </div>
                                    

                                    {/* 提交按鈕 */}
                                    <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                                        {isSubmitting ? "提交中..." : "提交申請"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddRequestForm;
